// @flow
import type {TreeRowData} from '../typedef';

export const isTotalWithoutChildren = <DataRow = {||}>(row: TreeRowData<DataRow>): boolean => {
    return Boolean(!row.children && row.isTotal);
};


            // @pb/generate-flow-typed Webpack Loader:
            // Duplicates all internal dependencies imports
            // to be sure all deps are parsed by this loader
            // cause Babel loader removes `import type ...`
            // and e.g. 'typedef.js' files are not included in dist
            
require("../typedef");
